import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router";

import {
  userDetailPath,
  UserListSortField,
  UserListUrlQueryParams,
  userManagementSection
} from "./urls";
import UserDetail from "./views/UserDetail";
import UserList from "./views/UserList";
import UserRoleGuide from "./views/UserRoleGuide";

const UserManagementSection = () => {
  const intl = useIntl();

  const UserListManagement: React.FC<RouteComponentProps<any>> = ({
    location
  }) => {
    const qs = parseQs(location.search.substr(1));
    const params: UserListUrlQueryParams = asSortParams(
      qs,
      UserListSortField,
      UserListSortField.employeeId
    );
    return <UserList params={params} />;
  };

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.userManagement)} />
      <Switch>
        <Route exact path={userManagementSection} render={UserListManagement} />
        <Route
          exact
          path={userDetailPath("/user-role-guide")}
          component={UserRoleGuide}
        />
        <Route exact path={userDetailPath(":id")} component={UserDetail} />
      </Switch>
    </>
  );
};

export default UserManagementSection;
